import { useEffect, useState } from 'react'

const usePhoneAvailability = ({
  phoneNumbers,
  reservationHotLine,
  pendingRequests,
  invoiceAddress,
  billingAddress,
  streetAddress,
  subscriptions,
  tcrCampaignId,
  status
}) => {
  const [isDisabled, setIsDisabled] = useState(false)
  const [disabledReason, setDisabledReason] = useState(null)

  useEffect(() => {
    const matchingPhoneWithHotline = phoneNumbers.find(
      p => p.phoneNumbers === reservationHotLine
    )

    if (!tcrCampaignId) {
      setIsDisabled(true)
      setDisabledReason('Missing TCR campaign ID')
      return
    }

    if (matchingPhoneWithHotline && matchingPhoneWithHotline.status === 'Provisioning') {
      setIsDisabled(true)
      setDisabledReason('Provisioning')
      return
    }

    if (pendingRequests.find(r => r.requestKind === 'TelecomChangeProvider')) {
      setIsDisabled(true)
      setDisabledReason('Pending telecom request')
      return
    }

    if (!reservationHotLine) {
      setIsDisabled(true)
      setDisabledReason('Missing hotline')
      return
    }

    if (!invoiceAddress) {
      setIsDisabled(true)
      setDisabledReason('Missing invoice address')
      return
    }

    if (!billingAddress) {
      setIsDisabled(true)
      setDisabledReason('Missing billing address')
      return
    }

    if (status === 'PendingCampaignBrandRegistration') {
      setIsDisabled(true)
      setDisabledReason('Pending campaign brand registration')
      return
    }

    if (!streetAddress) {
      setIsDisabled(true)
      setDisabledReason('Missing street in address')
      return
    }

    setIsDisabled(false)
    setDisabledReason(null)
  }, [
    phoneNumbers,
    pendingRequests,
    invoiceAddress,
    billingAddress,
    streetAddress,
    subscriptions,
    reservationHotLine,
    tcrCampaignId,
    status
  ])

  return { isDisabled, disabledReason }
}

export default usePhoneAvailability
